import { render, staticRenderFns } from "./DiagnosticHypothesisPanel.vue?vue&type=template&id=48885965&scoped=true&"
import script from "./DiagnosticHypothesisPanel.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHypothesisPanel.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticHypothesisPanel.vue?vue&type=style&index=0&id=48885965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48885965",
  null
  
)

export default component.exports